import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Observable} from "rxjs";
import {BackendService} from "@core/backendService/backend.service";
import {flow} from "lodash-es";
import {default as fp_map} from "lodash/fp/map";
import uniq from "lodash/fp/uniq";
import {map, startWith} from "rxjs/operators";
import {Point} from "@core/models/Point";
import {Purchase, Reward} from "@app/feature/reward/models/Reward";


export class RewardRedeemConfirmationData {
  participant_id: number
  send_to: string
  points: Point
  reward: Reward
  purchase: Purchase[]
}


@Component({
  selector: 'app-reward-redeem-confirmation',
  templateUrl: './reward-redeem-confirmation.component.html',
  styleUrls: ['./reward-redeem-confirmation.component.scss']
})
export class RewardRedeemConfirmationComponent implements OnInit {

  @ViewChild('emailInput', {static:false,read: ElementRef}) emailInput: ElementRef
  @Input() data: RewardRedeemConfirmationData
  @Output() onConfirm = new EventEmitter<RewardRedeemConfirmationData>()

  myControl = new FormControl();
  options: string[]= []
  filteredOptions: Observable<string[]>;

  constructor(public backendService: BackendService,) {}

  ngOnInit(): void {
    this.options = flow(
      fp_map('send_to'),
      uniq
    )(this.data.purchase) || []

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );

    this.data.send_to = this.backendService.isDummyEmail(this.data.send_to)
      ? null
      : this.data.send_to
  }

  confirm(){
    this.validate()
      ? this.onConfirm.emit(this.data)
      : null
  }

  validate(){
    return !!this.data.send_to && this.emailInput.nativeElement.validity.valid
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().indexOf(filterValue) === 0);
  }

}
